module.exports = __webpack_public_path__ + "static/bg2-06aff630e88f21d27e7e5bb1c6391ef6.jpg";